import * as React from "react";
import { TextArea, useFieldState, useFieldApi } from "informed";
import { inputClasses } from "../validation/ValidationClasses";

export const TextAreaWithStaticPrefix = ({ field, ...props }) => {
    const fieldState = useFieldState(field);
    const fieldApi = useFieldApi(field);

    return (
        <>
            <div className="input-group">
                <span className="input-group-addon">{props.staticpart}</span>
                <TextArea
                    field={field}
                    className={inputClasses(fieldApi.getError())}
                    {...props}
                />
            </div>
            {fieldApi.getError() ? <span className="field-validation-error">{fieldApi.getError()}</span> : null}
        </>
    );
}
